/**
* Hero Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'hero-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.hero-slider-splide' ).length ) {
        $( '.hero-slider-splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            classes: {
              pagination: 'splide__pagination hero-slider-pagination-btn',
            },
            perPage: 1,
            perMove: 1,
            type: 'slide',
            arrows: false,
            speed: 1000,
            drag: false,
            gap: 0,
            autoWidth: true,
          } );

          splide.on( 'pagination:mounted', function( data ) {
            data.items.forEach( function( item ) {
              item.button.textContent = String( item.page + 1 );
            } );

            const root = element.closest( '.hero-slider' );

            if ( !root || !data.list ) {
              return;
            }

            const publishWidth = function() {
              const rect = data.list.getBoundingClientRect();
              root.style.setProperty( '--hero-slider-pagination-space', Math.ceil( rect.width + 82 ) + 'px' );
              root.style.setProperty( '--hero-slider-pagination-height', Math.ceil( rect.height ) + 'px' );
            };

            publishWidth();

            splide.on( 'refresh updated resized', publishWidth );
            window.addEventListener( 'resize', publishWidth );

            if ( window.ResizeObserver ) {
              new ResizeObserver( publishWidth ).observe( data.list );
            }
          } );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-slider', COMPONENT );
} )( app );
